import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
  CircularProgress,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";

import TableToolbar from "./Components/TableToolbar";
import { esignToolApi } from "../../../services/esignApi";

const Superdashboard = () => {
  const [creditData, setCreditData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiPath, setApiPath] = useState("visitors");
  const [error, setError] = useState(null);
  const [timeFilter, setTimeFilter] = useState("today");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [allOrNewUsers, setAllOrNewUsers] = useState("allUsers");
  let superToken = localStorage.getItem("superToken");

  const [customRange, setCustomRange] = useState({
    start: "",
    end: "",
  });
  const [selectedValue, setSelectedValue] = useState("today");

  const fetchCreditData = async () => {
    setLoading(true);
    setError(null);
    try {
      let payload = {
        rows_per_page: rowsPerPage,
        allOrNewUsers,
        page: page + 1,
        timeframe: timeFilter,
        ...(timeFilter === "custom range" ? { range: customRange } : {}),
      };
      const response = await esignToolApi.getSuperadminCreditsData(
        apiPath,
        payload
      );
      setCreditData(response.data || []);
      // Assuming the API returns the total count in the response
      setTotalCount(response.page_data.total_data || 0);
    } catch (err) {
      console.error("Failed to fetch credit data:", err);
      setError("Failed to load credit usage data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!superToken) {
      window.location.href = "/superlogin";
    }
  }, []);

  useEffect(() => {
    fetchCreditData();
  }, [apiPath, timeFilter, page, rowsPerPage, allOrNewUsers]);

  const handleFilterChange = (event) => {
    setPage(0); // Reset to first page when filter changes
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  return (
    <Paper elevation={3} sx={{ padding: 2, m: 4 }}>
      <TableToolbar
        // timeFilter={timeFilter}
        handleFilterChange={handleFilterChange}
        customRange={customRange}
        setCustomRange={setCustomRange}
        selectedValue={selectedValue}
        setSelectedValue={setSelectedValue}
        setTimeFilter={setTimeFilter} // Pass this
        value={apiPath}
        setValue={setApiPath}
        allOrNewUsers={allOrNewUsers} 
        setAllOrNewUsers={setAllOrNewUsers}
      />
      {loading ? (
        <Box display="flex" justifyContent="center" p={3}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Box p={2} sx={{ textAlign: "center" }}>
          <Typography color="error">{error}</Typography>
        </Box>
      ) : (
        <>
          <TableContainer>
            <Table aria-label="credit usage table">
              <TableHead>
                <TableRow>
                  <TableCell>Visitor ID</TableCell>
                  <TableCell>Client IP</TableCell>
                  <TableCell>Company Name</TableCell>
                  <TableCell>Company Email</TableCell>
                  <TableCell>Total Credits</TableCell>
                  <TableCell>Added Credits</TableCell>
                  <TableCell>Left Credits</TableCell>
                  <TableCell>Completed</TableCell>
                  <TableCell>Pending</TableCell>
                  <TableCell>Expired</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Visited At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {creditData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                ) : (
                  creditData.map((row) => (
                    <TableRow key={row.visitor_id}>
                      <TableCell>{row.visitor_id}</TableCell>
                      <TableCell>{row.client_ip}</TableCell>
                      <TableCell>{row.company_name}</TableCell>
                      <TableCell>{row.company_email}</TableCell>
                      <TableCell>{row.total_credits}</TableCell>
                      <TableCell>{row.credits_added}</TableCell>
                      <TableCell>{row.left_credits}</TableCell>
                      <TableCell>{row.completed}</TableCell>
                      <TableCell>{row.pending}</TableCell>
                      <TableCell>{row.expired}</TableCell>
                      <TableCell>
                        {row?.created_at
                          ? new Date(row?.created_at).toLocaleString()
                          : ""}
                      </TableCell>
                      <TableCell>
                        {row?.visitor_created_at
                          ? new Date(row?.visitor_created_at).toLocaleString()
                          : ""}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </Paper>
  );
};

export default Superdashboard;
